import React from 'react';
import PropTypes from 'prop-types';
import { Table, Header } from 'semantic-ui-react';
import LocationListRow from './LocationListRow';

const LocationList = props => {
  const { auctionLocationList, onSelectAuctionLocation, isAuctionLocationEditor } = props;

  const headerRow = (
    <Table.Row>
      <Table.HeaderCell>Name</Table.HeaderCell>
      <Table.HeaderCell>Location / IMS Code</Table.HeaderCell>
      <Table.HeaderCell>External Auction Code</Table.HeaderCell>
      <Table.HeaderCell>Auction System</Table.HeaderCell>
      <Table.HeaderCell>Purchases</Table.HeaderCell>
      <Table.HeaderCell>Returns</Table.HeaderCell>
      <Table.HeaderCell>Inspections</Table.HeaderCell>
      <Table.HeaderCell>DS Paid PSI</Table.HeaderCell>
      <Table.HeaderCell>Title Days</Table.HeaderCell>
      <Table.HeaderCell>Sale Day(s)</Table.HeaderCell>
      <Table.HeaderCell>Supplier Number</Table.HeaderCell>
      <Table.HeaderCell>Macola Inventory Code </Table.HeaderCell>
      <Table.HeaderCell>Address</Table.HeaderCell>
      <Table.HeaderCell>Return Instructions</Table.HeaderCell>
      <Table.HeaderCell>Return Emails</Table.HeaderCell>
      <Table.HeaderCell>External Auctions Email</Table.HeaderCell>
      <Table.HeaderCell>Additional Email</Table.HeaderCell>
      <Table.HeaderCell />
    </Table.Row>
  );

  return (
    <div>
      <Header>Auction Locations</Header>
      <div className='location_table'>
        <Table
          celled
          selectable
          padded
          renderBodyRow={(data, index) => (
            <LocationListRow
              key={index}
              location={data}
              actionHandler={onSelectAuctionLocation}
              isAuctionLocationEditor={isAuctionLocationEditor}
            />
          )}
          tableData={auctionLocationList}
          headerRow={headerRow}
          size='small'
          compact='very'
          style={{ fontSize: '90%' }}
          striped
          className='pre-wrap-table'
        />
      </div>
    </div>
  );
};

LocationList.propTypes = {
  auctionLocationList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSelectAuctionLocation: PropTypes.func.isRequired,
  isAuctionLocationEditor: PropTypes.bool.isRequired,
};

export default LocationList;
